import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchCurrentDate } from "../../api/api";
import { fetchCurrentDateSuccess, fetchCurrentDateFailure } from "./date";

export function* handleFetchCurrentDate(): SagaIterator {
  try {
    const data = yield call(fetchCurrentDate);
    yield put(fetchCurrentDateSuccess(data));
  } catch (error) {
    yield put(fetchCurrentDateFailure(error.message));
  }
}
